import React from 'react';

const Leaderboard: React.FC = () => {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="win-card p-6">
        <h1 className="text-3xl font-bold text-win-dark-text">Leaderboard</h1>
        <p className="text-win-dark-text-muted">See how you rank against other traders</p>
      </div>
      {/* Leaderboard content will be implemented */}
    </div>
  );
};

export default Leaderboard;